import { NON_DIGITS_REGEX } from 'shared/constants/regex.ts'

export function parseHotelStars(starsString: string | null): number {
  if (!starsString) {
    return 0
  }

  return parseInt(starsString.trim().replace(NON_DIGITS_REGEX, ''), 10)
}
